// src/modules/app-views/crm/pages/Kanban/modals/NewOpportunityModal/Step1.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Col, Row, Spin, Typography, Upload } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import SimpleSelect from 'components/SimpleComponents/SimpleSelect';
import useZustand from 'hooks/useZustand';
import translateX from 'utils/translateX';

const { Dragger } = Upload;
const { Text } = Typography;

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const Step1 = ({ fileList, onFileListChange, processing }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const storedParameters = useZustand('app', 'parameters');

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const boards = storedParameters?.modules?.crm?.boards || [];
  const boardOptions = boards.map(b => ({ value: b.uid, label: b.title, text: b.title }));
  const hasFile = fileList.length > 0;

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────
  const handleChange = ({ fileList: newList }) => {
    onFileListChange(newList.slice(-1));
  };

  const uploadProps = {
    name: 'file',
    multiple: false,
    maxCount: 1,
    accept: 'image/*',
    listType: 'picture',
    fileList,
    beforeUpload: () => false, // prevent auto-upload; parent manages the list
    onChange: handleChange,
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <Spin spinning={!!processing} description={translateX('ai_reading_card')}>
      <div className="p-2">
        {/* Board selector */}
        <Row gutter={16}>
          <Col xs={24}>
            <SimpleSelect
              name="boardUid"
              label="board"
              options={boardOptions}
              disabled={true}
              required
            />
          </Col>
        </Row>

        {/* Upload area:
            - No file: show Dragger (drag/drop zone with icon and hints)
            - File attached: hide Dragger, show only the file thumbnail + delete icon */}
        <Row gutter={16}>
          <Col xs={24}>
            {hasFile ? (
              // File attached — show only the file list entry (trash removes and reveals Dragger)
              <Upload {...uploadProps} />
            ) : (
              // No file — show full drag/drop zone
              <Dragger {...uploadProps}>
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">{translateX('upload_card_hint')}</p>
                <p className="ant-upload-hint">
                  <Text type="secondary">{translateX('upload_card_hint_sub')}</Text>
                </p>
              </Dragger>
            )}
          </Col>
        </Row>
      </div>
    </Spin>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default Step1;
